module.exports = "/assets/cola-page/logo_1.png?Bru+FSS";